import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {IShipServiceRemote} from '../../interfaces/iship-service-remote';
import {ICruiseDetail} from '../../interfaces/icruise-detail';
import {CmsService} from '../../../../../cms/services/cms.service';
import {WidgetService} from "../../../../../shared/services/widget.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cruise-detail-content-ship',
  templateUrl: './cruise-detail-content-ship.component.html',
  styleUrls: ['./cruise-detail-content-ship.component.scss']
})
export class CruiseDetailContentShipComponent implements OnInit, OnChanges, OnDestroy {

  @Input() shipService$: Observable<IShipServiceRemote>;
  @Input() cruise$: Observable<ICruiseDetail>;
  @Input() bookingUrl: string;

  shipDetails: IShipServiceRemote;
  selectedDeck: any;
  selectedCabin: any = null; // attenzione: da non confondere con il selectedCabin della griglia solutions/prezzi!
  brand: any;

  private brandConfigSubscription: Subscription;

  public isLanding: boolean;

  config = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      bulletActiveClass: 'swiper-pagination-bullet-active',
    }
  };

  //  Configurazione specifica nel caso di una sola immagine disponibile
  singleImgConfig = {
    navigation: false,
    pagination: false,
    allowTouchMove: false
  };

  index;
  indexCarousel;
  showLegend;

  public isWidget$: Observable<boolean>;

  constructor(
    private _cmsService: CmsService,
    private _widgetService: WidgetService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const segments = this._route.snapshot['_urlSegment'].segments.map(x => x.path);
    this.isLanding = segments[0] == 'landing';

    this.isWidget$ = this._widgetService.isWidget();

    this.indexCarousel = 0;
    this.index = 0;
    this.brandConfigSubscription = this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) this.brand = brand;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.shipService$ && this.shipService$) {
        this.shipService$.subscribe( shipDetails => {
          this.shipDetails = shipDetails
          if (!this.selectedDeck && this.shipDetails.decks?.plant?.length) {
            this.selectedDeck = this.shipDetails.decks.plant[0];
          }
          if (!this.shipDetails.cabins?.length) return;
          this.shipDetails.cabins?.forEach(cabin => {
            cabin.images = cabin.images?.filter(image => image.image_path.toLowerCase().includes('.jpeg') || image.image_path.toLowerCase().includes('.jpg') || image.image_path.toLowerCase().includes('.png') );
            if (!cabin.images?.length) {
              cabin.images = [this.getRandomImage()];
            }
            if (!this.selectedCabin) {
              this.cruise$.subscribe(e => {
                // NB: il filter serve per rimuovere i valori "nullable" o vuoti dall'array che potrebbero generare errori
                const cabinWithPrice = (e?.selectedSolution?.cabins?.length) ? [...e.selectedSolution.cabins].filter(x => x) : [];
                if(!cabinWithPrice.length) return;
                let cheapestPrice = cabinWithPrice[0].price;
                let cheapestCabin = cabinWithPrice[0];
                cabinWithPrice.forEach(cabin => {
                  if(cabin.price < cheapestPrice) {
                    cheapestCabin = cabin;
                    cheapestPrice = cabin.price
                  }
                })
                this.selectedCabin = this.shipDetails.cabins.find( cabin => cabin.category?.toLowerCase() === cheapestCabin.description?.toLowerCase());
                if (!this.selectedCabin) {
                  this.selectedCabin = this.shipDetails.cabins[0];
                } else {
                  this.shipDetails.cabins.sort( (a,b) => a.description === this.selectedCabin.description ? -1 : 1)
                }
              })
            }
          })
        })
      }
  }

  ngOnDestroy(): void {
    this.brandConfigSubscription?.unsubscribe();
  }

  getRandomImage(){
    return {image_path : `assets/images/rooms/room-${Math.round(Math.random() * 9)}.jpg`, type: 'default'};
  }

  //  Riporta lo slider delle immagini delle cabine sulla prima foto (viene richiamata quando cambia la cabina selezionata)
  resetImgIndex() {
    this.index = 0;
  }

}
